module.exports = __webpack_public_path__ + "bc7c4a59f924cf037aad6e1f9edba366.eot";


//////////////////
// WEBPACK FOOTER
// ./~/react-widgets/lib/fonts/rw-widgets.eot
// module id = 1758
// module chunks = 0